import awsExports from '../awsExports';

const getDiscoveryBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_SSO_DISCOVERY_ENDPOINT || awsExports.aws_download_endpoint;
  return String(configuredUrl || '').replace(/\/$/, '');
};

const buildDiscoveryError = (response, body) => {
  const error = new Error(body.message || 'Failed to load SSO discovery.');
  error.statusCode = response.status;
  return error;
};

export const getPublicSsoDiscovery = async ({ customerId, signal }) => {
  const normalizedCustomerId = String(customerId || '').trim();
  if (!normalizedCustomerId) {
    return {
      identityProviders: [],
      passwordLoginEnabled: true,
    };
  }

  const baseUrl = getDiscoveryBaseUrl();
  if (!baseUrl) {
    throw new Error('Public SSO discovery endpoint is not configured.');
  }

  const url = new URL(`${baseUrl}/sso/discovery`);
  url.searchParams.set('customerId', normalizedCustomerId);

  const response = await fetch(url.toString(), { signal });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildDiscoveryError(response, body);
  }

  return {
    identityProviders: Array.isArray(body.identityProviders) ? body.identityProviders : [],
    passwordLoginEnabled: body.passwordLoginEnabled !== false,
  };
};
